import Badge from "./Badge";
import Avatar from "./Avatar";
import { productType } from "types/productType";
import { useEffect, useState } from "react";

export default function ViewContents ({
	title,
	description
}: any) {

	let [ visible, setVisible ] = useState <string> ("hidden");
	//let [ desc, setDesc ] = useState <string> ("");

	useEffect(() => {

		if (description === undefined || description === null || description === "") {
			setVisible("hidden");
		} else {
			setVisible("");
		}
	}, [description])

	return (
		<div id="information" className={`listingSection__wrap space-y-0 p-0 ${visible}`}>
			<div className="flex justify-between pl-5 pt-5 pr-5 pb-5">
				<h2 className="text-lg sm:text-2xl  font-semibold font-snas-kr">
					{title}
				</h2>
				<div>
					
				</div>
				
			</div>
			<div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
						
			<div className="text-neutral-6000 dark:text-neutral-300 bg-white pt-5 pb-5 rounded-b-2xl">
				<div
					className="ql-editor !min-h-[50px]"
					dangerouslySetInnerHTML={{ __html: description}}
				/>
			</div>
		</div>
	);
};